import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';

@Api('api/agentic-cx/crm-segment-definition')
export class CrmSegmentDefinitionDto extends DtoHasApi {
  id = 0;
  name = '';
  contactCount?: number;
}
